import { render } from "./Tasas.vue?vue&type=template&id=6773c45b&scoped=true"
import script from "./Tasas.vue?vue&type=script&lang=js"
export * from "./Tasas.vue?vue&type=script&lang=js"

import "./Tasas.vue?vue&type=style&index=0&id=6773c45b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6773c45b"]])

export default __exports__